"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsFile = checkIsFile;
function checkIsFile(name) {
    return name.endsWith('pdf') || name.endsWith('csv') || name.endsWith('txt');
}
;
